import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/sell-my-car/")({
  head: () => routeHead("/uk/sell-my-car/"),
  beforeLoad: () => {
    throw redirect({ href: "/uk/vinde-masina", statusCode: 301, replace: true });
  },
});
